import { useDisclosure } from "@heroui/react";
import {
  InputField,
  ModalBuilder,
  ModalError,
} from "@/app/components/modals/modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { loadHandbooks } from "@/utils/loadHandbooks";
import { useAppSelector } from "@/hooks/useAppSelector";

interface CreateTtlockSystemForm {
  displayName: string;
  clientId: string;
  clientSecret: string;
  username: string;
  password: string;
}

const createTtlockSystemFields: InputField[] = [
  {
    label: "Название",
    name: "displayName",
    placeholder: "Название",
    type: "text",
    isRequired: true,
  },
  {
    label: "Client ID",
    name: "clientId",
    placeholder: "0xFFFFFF",
    type: "text",
    isRequired: true,
  },
  {
    label: "Client Secret",
    name: "clientSecret",
    placeholder: "0xFFFFFF",
    type: "text",
    isRequired: true,
  },
  {
    label: "Имя пользователя",
    name: "username",
    placeholder: "0xFFFFFF",
    type: "text",
    isRequired: true,
  },
  {
    label: "Пароль",
    name: "password",
    placeholder: "0xFFFFFF",
    type: "text",
    isRequired: true,
  },
];

export function CreateTtlockSystemModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();
  const businessProfileId = useAppSelector(
    (state) => state.businessProfile.businessProfile.id,
  );

  const onSubmit = (data: CreateTtlockSystemForm) => {
    return new Promise<boolean>((resolve) => {
      api.lockSystems
        .create({
          display_name: data.displayName,
          business_profile_id: businessProfileId,
          type: "ttlock",
          credentials: {
            clientId: data.clientId,
            clientSecret: data.clientSecret,
            username: data.username,
            password: data.password,
          },
        })
        .then(() => {
          loadHandbooks({ handbooks: ["locks"] });
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          loadHandbooks({ handbooks: ["locks"] });
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание системы TTLOCK"
      fields={createTtlockSystemFields}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      isSensitiveData={true}
      submitButtonText="Сохранить"
      defaultValues={{
        clientId: "",
        clientSecret: "",
        username: "",
        password: "",
      }}
    />
  );
}
